import React, { CSSProperties, FC } from 'react';

import Icon from '../../icons/Button/IconButton';
import XClose from '../../icons/XClose/XClose';

export interface DismissProps {
  s?: CSSProperties;
  onClick?: () => void;
}

const Dismiss: FC<DismissProps> = ({ s = {}, onClick }) => {
  return (
    <Icon onClick={onClick} ariaLabel="close">
      <XClose s={s} />
    </Icon>
  );
};

export default Dismiss;
